module.exports = __webpack_public_path__ + "static/img/yd_Icon.e282a7a6.png";